module.exports = __webpack_public_path__ + "static/media/band-champion-no-txt.9f37cf44.svg";